import React, { useEffect, useState } from 'react'
import { getProductionsWithPage } from "../../services/serviceProduction";
import { Button, Card, Table } from "antd";
import ProductionCreate from "./ProductionCreate";
import userDateFormatter from "../../services/formatters/userDateFormatter";
import ProductionActions from "./ProductionActions";

const Production = () => {
    const [newModal, setNewModal] = useState(false);
    const [sortedList, setSortedList] = useState([]);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });

    useEffect(() => {
        getProductions(pagination.current, pagination.pageSize);
    }, [pagination.current, pagination.pageSize])

    const getProductions = (page, pageSize) => {
        getProductionsWithPage(page - 1, pageSize)
            .then(({ data }) => {
                handlers.sortData(data.content);
                setPagination({
                    ...pagination,
                    total: data.totalElements,
                })
            })
    };

    const handlePaginationChange = (pageNumber, pageSize) => {
        setPagination({
            ...pagination,
            current: pageNumber,
            pageSize: pageSize
        });
    };

    const handlers = {
        updater() {
            getProductions(1, 10);
        },
        modalCloser() {
            setNewModal(!newModal)
        },
        sortData(list) {
            let sorted = []
            list.map((item) => {
                let pushObj = {
                    key: item.id,
                    id: item.id,
                    closed: item.closed ? item.closed : false,
                    productionNumber: item.productionNumber,
                    productionCustomer: item.customer.name,
                    customer: item.customer,
                    recipeName: item.recipe.name,
                    productionEndDate: item.endDate,
                    productionStartDate: item.startDate,
                    productionNote: item.note,
                    productionQuantity: item.quantity,
                }
                sorted.push(pushObj)
            })
            setSortedList(sorted)
        }
    };

    const columns = [
        {
            title: 'Üretim Numarası',
            dataIndex: 'productionNumber'
        },
        {
            title: 'Reçete Adı',
            dataIndex: 'recipeName'
        },
        {
            title: 'Müşteri Adı',
            dataIndex: 'productionCustomer',
            key: 'productionCustomer'
        },
        {
            title: 'Miktar',
            dataIndex: 'productionQuantity'

        },
        {
            title: 'Başlangıç Tarihi',
            dataIndex: 'productionStartDate',
            key: 'productionStartDate',
            render: (text) => userDateFormatter(text)
        },
        {
            title: 'Bitiş Tarihi',
            dataIndex: 'productionEndDate',
            key: 'productionEndDate',
            render: (text) => userDateFormatter(text)
        },
        {
            title: 'İşlemler',
            render: (text, record) => <ProductionActions updater={handlers.updater} record={record} />
        }
    ];

    return (
        <React.Fragment>
            <Card
                title={'Üretim Emri Listesi'}
                extra={<Button onClick={() => setNewModal(!newModal)} type={'primary'}> Yeni Ekle</Button>}
            >
                <Table
                    scroll={{ x: 'max-content' }}
                    columns={columns}
                    dataSource={sortedList}
                    pagination={{
                        ...pagination,
                        showSizeChanger: true,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        onChange: handlePaginationChange,
                    }}
                />
            </Card>

            {newModal ? <ProductionCreate updater={handlers.updater} modalCloser={handlers.modalCloser}
                show={newModal} /> : null}
        </React.Fragment>
    )
}
export default Production